module.exports = __webpack_public_path__ + "img/Ancho_Leyes.deecb326.png";